import { FilterValues, OptionsSlice } from './store/types'

export type VisibilityParams = FilterValues & OptionsSlice['options']

/**
 * Видимость фильтров в зависимости от значений других фильтров или внешних параметров
 */
const visibilityRules = {
  orgs: (_: VisibilityParams) => true,
  buildings: () => true,
  // ADD NEW HERE
}

function typedKeys<T extends object>(obj: T) {
  return Object.keys(obj) as Array<keyof T>
}

export function calculateVisibility(context: VisibilityParams) {
  const result = {} as Record<keyof typeof visibilityRules, boolean>
  for (const key of typedKeys(visibilityRules)) {
    result[key] = visibilityRules[key](context)
  }
  return result
}
